// extracted by mini-css-extract-plugin
module.exports = {"leftRailWithSplitRow":"leftRailWithSplitRow___1gzLr","main":"main___1aUnE","splitCol":"splitCol___2O-6X","split":"split___V9G_5"};